import React from 'react';

import styles from '../FooterSimplified.module.scss';

const FooterSimplifiedSection = props => (
  <div className={styles.footer__section}>{props.children}</div>
);

export default FooterSimplifiedSection;
